// extracted by mini-css-extract-plugin
module.exports = {"root":"Courses_root__1X86e","header":"Courses_header__22Zoh","card":"Courses_card__3egar","title":"Courses_title__3b89J","btn":"Courses_btn__2tde1"};